import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  TemplateRef,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';

import { SliderBaseInterface } from '../interfaces/slider.interface';
import { SliderBaseComponent } from '../slider-base/slider-base.component';

@Component({
  selector: 'mb-item-slider',
  templateUrl: './item-slider.component.html',
  styleUrls: ['./item-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [SliderBaseComponent, NgTemplateOutlet],
})
export class ItemSliderComponent<T extends { id?: string | number }> {
  @Input() config: SliderBaseInterface = {
    inGrid: true,
    itemsToSlide: 1,
    itemsToShow: 1,
  };
  @Input() itemTpl!: TemplateRef<any>;
  @Input() items!: T[];
  @Input() initialIndex: number = 0;
  @Output() indexChanged = new EventEmitter();
}
